<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/KKgEB4/tc-custom/9781439646892.jpg?1684305910238" alt="This image is the cover for the book Blue Ridge Mountains of North Carolina, Postcard History Series"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Blue Ridge Mountains of North Carolina, Postcard History Series
      </h1>
      <p class="bookDescription body article font2">
        <p>Running along the western border of the state, the Blue Ridge Mountains of North Carolina have beckoned explorers, settlers, and tourists for generations. Within the ridges and valleys of these mountains, spectacular natural features abound, such as Blowing Rock, Looking Glass Falls, and Linville Gorge. Here, the highest mountain peak in North Carolina, Mount Mitchell, rises to an astonishing 6,684 feet. Recreationally, these mountains boast massive tourist appeal; visitors can hike the Appalachian Trail, drive the Blue Ridge Parkway, or explore the Great Smoky Mountains National Park. This title showcases the natural beauty of the unique mountain range and the numerous mountain communities that many call home.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Janet Morrison
      </h2>
      
      <p class="authorDescription body article">Janet Morrison, of Harrisburg, North Carolina, has a bachelor's degree in political science from Appalachian State University and a master's degree in public affairs from North Carolina State University. Images within come exclusively from her large collection of North Carolina postcards.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Arcadia Publishing
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?295325b1